module.exports = {
  title: 'Blog', // Required
  author: 'Cowichan Fournier', // Required
  description: 'Je présente dans ce blog tout ce qui concerne le développement web',
  primaryColor: '#3498db', // Required
  showHeaderImage: true,
  showShareButtons: true,
  postsPerPage: 5, // Required
  social: {
    website: 'https://www.cowichanfournier.com/',
    // github: 'https://github.com/ryanfitzgerald',
    // twitter: 'https://twitter.com/ryanafitzgerald',
    linkedin: 'https://www.linkedin.com/in/cowichanfournier/',
  },
  pathPrefix: '/',
  siteUrl: 'https://www.cowichanfournier.com/',
};
